module.exports = __webpack_public_path__ + "static/media/logo.0bf191ee.svg";